import React, {Suspense} from 'react'
import {RecordsManager, UploaderAction} from './lib/service'
import {UploadPanel} from './panel/UploadPanel'
import {Fill, useToggle} from '@startlibs/core'
import {AddStudiesButton} from './AddStudiesButton'
import {UploadLogDialog} from './UploadLogDialog'
import {FullPageDroppable} from './FullPageDroppable'
import {getFetcher, wrapLazy} from '@startlibs/utils'
import _ from 'lodash/fp'
import {createAutoRefreshableJwtFromLazy} from './lib/utils/autoRefershableJwtFromLazy'
import {lazyStudyUserRights} from '../lazy/lazyStudyUserRights'
import {isDev} from './lib/utils/common'
import {UploaderDialog} from './UploaderPage'


const lazyJwt = wrapLazy(() => getFetcher("/dicomuploaderjwt.php?mode=app").then(_.trim))
const getJwt = createAutoRefreshableJwtFromLazy(lazyJwt, 2)

export const Uploader = ({setUploadPanelOn}) => {

  const uploadLogDialog = useToggle()
  const uploaderDialog = useToggle()
  const {options,worklistMenus} = lazyStudyUserRights.read()

  const showCreateBlankStudy = isDev || worklistMenus?.createBlankStudy
  const showUpload = isDev || worklistMenus?.upload

  const disabled = (!isDev && !options?.use_integrated_web_uploader) || (!showUpload && !showCreateBlankStudy)

  return <RecordsManager
        getJwt={getJwt}
        disabled={disabled}
        resolveJwt={lazyJwt.promise}
      >{(records, data, doAction) => <>
        <Fill name="AddStudiesButton">
          <AddStudiesButton showUpload={showUpload} showCreateBlankStudy={showCreateBlankStudy} fileEventHandler={doAction(UploaderAction.UploadFromEvent)}/>
        </Fill>
        {
          showUpload && <>
            <FullPageDroppable fileEventHandler={doAction(UploaderAction.UploadFromEvent)} />
            <UploadPanel openUploadDialog={uploaderDialog.open} hidden={uploadLogDialog.isOpen} uploadLogDialog={uploadLogDialog} doAction={doAction} records={records} data={data} setUploadPanelOn={setUploadPanelOn}/>
            {
              uploadLogDialog.isOpen && <UploadLogDialog closeDialog={uploadLogDialog.close} filter={uploadLogDialog.isOpen.filter} />
            }
            {
              uploaderDialog.isOpen &&
              <UploaderDialog
                uploadLogDialog={uploadLogDialog}
                records={records}
                data={data}
                doAction={doAction}
                closeDialog={uploaderDialog.close}
              />
            }
          </>
        }
      </>}</RecordsManager>
}
